import React from "react";

import { useState } from "react";

import { Alert, AlertTitle } from "@material-ui/lab";
import {  Snackbar } from "@material-ui/core";

const ZatckNotification = () => {
    const [snack, setSnack] = useState({
      vertical: "top",
      openSnak: true,
      horizontal: "right",
      severit: "warning",
      text:
        "هناك فواتير لم يتم ترحيلها...برجاء التاكد من ترحيل الفواتير قبل 24 ساعه من اصدارها",
      time: 10000,
    });
  
    return (
      <div>
  
        <Snackbar
          anchorOrigin={{ vertical:"", horizontal:"" }}
          open={snack.openSnak}
          autoHideDuration={snack.time}
          onClose={()=>{setSnack({ ...snack, openSnak: false })}}
          key={"12"}
         
        >
          <Alert onClose={()=>{
            setSnack({ ...snack, openSnak: false })
          }} severity={snack.severit}>
            {" "}
            {snack.text}{" "}
          </Alert>
        </Snackbar>
      </div>
    );
  };

  export default ZatckNotification;